module.exports = __webpack_public_path__ + "static/media/IMG_0813.1b9ee02c.jpg";